import apiService from 'src/shared/config/apiService';

type SignupConfigResponse = {
  open_sign_up: boolean;
};

export const getSignupConfig = async (): Promise<SignupConfigResponse> => {
  const { data } = await apiService.get<SignupConfigResponse>('/signup-config');

  return data;
};
